<template>
  <div class="layout bg-white">
    <div class="w-full py-2 md:py-3 px-4 md:px-6">
      <div :class="['flex items-start justify-between', stackUntilXl && 'md:flex-col md:gap-3 xl:flex-row xl:gap-0']">
        <div :class="['flex-1 min-w-0', stackUntilXl && 'md:w-full xl:w-auto']">
          <h1 class="text-lg md:text-2xl font-bold text-black leading-tight">{{ title }}</h1>
          <slot name="subtitle">
            <p v-if="subtitle" class="mt-0.5 md:mt-1 text-xs md:text-sm text-black">{{ subtitle }}</p>
          </slot>
        </div>
        <div v-if="$slots.extra" :class="['flex items-center gap-3 relative z-10 mt-0.5 md:mt-1', stackUntilXl && 'md:w-full xl:w-auto']">
          <slot name="extra"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PageHeaderProps } from '@/types/ui'

withDefaults(defineProps<PageHeaderProps>(), {
  showExport: false,
  showSave: false,
  stackUntilXl: false
})
</script>

<style scoped>

.layout{
  margin-left:-17px;
  margin-right: -20px;

}
</style>
